export enum BillingFrequencyEnum {
    Unknown = 1,
    Monthly10Pay = 2,
    Monthly11Pay = 3,
    Monthly = 4,
    Annually = 5,
    SemiMonthly20Pay = 6,
    SemiMonthly22Pay = 7,
    SemiMonthly = 8,
    BiWeekly = 9,
    SemiAnnually = 10,
    Quarterly = 11,
    Weekly = 12,
    WeeklyMax26 = 13,
    BiWeekly24Ded = 14,
    BiWeekly21Pay = 15,
    Percentage = 16,
    Single = 17,
    SemiMonthly18Pay = 18,
}
